import {Injectable, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthService} from './auth.service';
import Swal from 'sweetalert2';
import { DatatableComponent } from '../../shared/components/datatable/datatable.component';
import { MyAccountService } from './my-account.service';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  @ViewChild(DatatableComponent) datatable!: DatatableComponent;

  constructor(private authService: AuthService, private myAccountService: MyAccountService) {
  }

  public header: any = {
    Authorization: this.authService.getToken,
  }

  updateSetting(url: string, body: any): Observable<any> {
    return this.myAccountService.httpPut(url, body, this.header);
  }

  getSettingTiles(): Observable<any> {
    return this.myAccountService.httpGet(`subscription/count`, this.header);
  }

    confirmUpdate(event: any): void {
      Swal.fire({
          title: 'Are you sure?',
          html: `You want to update ${String(event.colDef.headerName).toLocaleLowerCase()}`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
      }).then(result => {
          if (result.isConfirmed) {
            this.updateSettingDetail(event);
          }
      });
    }

    updateSettingDetail(event: any): void {
      const id = event.node.data.id
      this.updateSetting(`setting/${id}`, event.data).subscribe(
          response => {
              Swal.fire('Success', `The ${String(event.colDef.headerName)} has been updated`, 'success');
              this.datatable.refreshData();
          },
          error => {
            const errMsg = error.error.errors[String(event.colDef.field)] ?? error.error.errors
            Swal.fire('Error!', errMsg, 'error');
            console.error(`Error updating ${String(event.colDef.headerName)}`, error);
            this.datatable?.refreshData();
          }
      );
    }
}
